import { Typography } from '@breetometer/components';
import { classNameMerger } from '@breetometer/utils';
import { AssetInfoIcon, FiatIcon } from 'BreetAssets';
import { ImageComponent } from 'BreetComponents';
import { capitalizeFirstLetter, type CURRENCYCODETYPE, CURRENCYCONFIG, getSafeObjectField, type ISellAssets } from 'BreetHelpers';
import { useCryptoSettingsApi } from 'BreetHooks';

const ConversionInfo = ({ selectedAsset, isAssetGroup }: { selectedAsset?: ISellAssets; isAssetGroup: boolean }) => {
	const { currentReceiveCurrency, isLoading } = useCryptoSettingsApi();

	const currencyProps = getSafeObjectField(
		CURRENCYCONFIG,
		currentReceiveCurrency?.toUpperCase() as CURRENCYCODETYPE,
		CURRENCYCONFIG.USD
	);

	return (
		<div className='assetiteminfo_infodata'>
			<div className='assetiteminfo_infodata_item wallet'>
				<ImageComponent src={selectedAsset?.avatar as unknown as string} />
				<div>
					<Typography
						as='label'
						className={classNameMerger('color-primary-50 truncate', isLoading && 'global-skeleton')}
						title={isAssetGroup ? selectedAsset?.name : selectedAsset?.identifier}
					>
						{isAssetGroup ? selectedAsset?.name : selectedAsset?.identifier}
					</Typography>
					<Typography>{isAssetGroup ? selectedAsset?.symbol : selectedAsset?.name}</Typography>
				</div>
			</div>
			<div className='assetiteminfo_infodata_item icon'>
				<AssetInfoIcon />
			</div>
			<div className='assetiteminfo_infodata_item wallet end'>
				<FiatIcon currencyCode={currencyProps.code} />
				<div>
					<Typography
						as='label'
						className={classNameMerger('color-primary-50', isLoading && 'global-skeleton')}
					>
						{currencyProps.code}
					</Typography>
					<Typography>{capitalizeFirstLetter(currencyProps.currencyShort)}</Typography>
				</div>
			</div>
		</div>
	);
};

export default ConversionInfo;
